import React from 'react'
import RegisterForm from '../../components/Auth/RegisterForm/RegisterForm'

const RegisterPage = () => {
  return (
    <div className="bg-[#0B1420]">
      <RegisterForm />
    </div>
  )
}

export default RegisterPage
